import { AbstractGenerateWorkplaceEntitiesStep } from './abstract-generate-workplace-entities-step';

export class GenerateWorkplaceTimeModelsStep extends AbstractGenerateWorkplaceEntitiesStep {

}
